import React from "react";
import styled from "styled-components";

interface Props {
  label: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const FieldWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const Label = styled.label`
  font-family: "IBM Plex Mono";
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #000;
`;

const Input = styled.input<{ disabled?: boolean }>`
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  background-color: ${(props) => (props.disabled ? "#f2f2f2" : "#fff")};
  outline: none;

  &:focus {
    border-color: #3b6255;
  }
`;

interface Props {
  label: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const UserInfoField: React.FC<Props> = ({ label, value, onChange, disabled }) => {
  return (
    <FieldWrapper>
      <Label>{label}</Label>
      <Input
        type="text"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </FieldWrapper>
  );
};

export default UserInfoField;
